export function showByPermission(permission: string) {
  return permission !== 'hidden'
}
